export default __webpack_public_path__ + "static/media/Logo_ireachify-logo-04-1-scaled.1a19a3da.jpg";